import React, { useState, useEffect, useCallback } from 'react';
import alert_A_bg from './Images/ImagesForAlert/alert_A_bg.png';
import yes_n from './Images/ImagesForAlert/yes_n.png';
import yes_o from './Images/ImagesForAlert/yes_o.png';
import no_n from './Images/ImagesForAlert/no_n.png';
import no_o from './Images/ImagesForAlert/no_o.png';

interface CustomConfirmationProps {
    message: string;
    onConfirm: () => void;
    onClose: () => void;
}

const CustomConfirmation: React.FC<CustomConfirmationProps> = ({ message, onConfirm, onClose }) => {
    const [isYesHovered, setIsYesHovered] = useState(false);
    const [isNoHovered, setIsNoHovered] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [offset, setOffset] = useState({ x: 0, y: 0 });

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        setIsDragging(true);
        setOffset({
            x: e.clientX - position.x,
            y: e.clientY - position.y
        });
    };

    const handleMouseMove = useCallback((e: MouseEvent) => {
        if (isDragging) {
            setPosition({
                x: e.clientX - offset.x,
                y: e.clientY - offset.y
            });
        }
    }, [isDragging, offset]);

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    useEffect(() => {
        if (isDragging) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        } else {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        }
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, handleMouseMove]);

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(204, 204, 204, 0.5)',
            zIndex: 20000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: isDragging ? 'all' : 'auto'
        }}>

            <div style={{
                width: '506px',
                height: '246px',
                backgroundImage: `url(${alert_A_bg})`,
                backgroundRepeat: 'no-repeat',
                position: 'relative',
                fontFamily: 'Tahoma',
                fontSize: '14px',
                color: 'white',
                transform: `translate(${position.x}px, ${position.y}px)`,
                userSelect: 'none' 
            }}>

                <div 
                    onMouseDown={handleMouseDown}
                    style={{
                        width: '100%',
                        height: '30px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingLeft: '15px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        position: 'relative',
                        cursor: isDragging ? 'move' : 'move'
                    }}
                >
                    Confirmation
                </div>

                <div style={{
                    height: '145px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 20px',
                    color: 'black',
                    overflowY: 'auto',
                    textAlign: 'center'
                }}>
                    <div style={{paddingLeft:'30px'}} dangerouslySetInnerHTML={{ __html: message }} />
                </div>

                <div style={{
                    height: '70px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <img
                        src={isYesHovered ? yes_o : yes_n}
                        alt="Yes"
                        onClick={onConfirm}
                        style={{ cursor: 'pointer', margin: '0 10px' }}
                        onMouseEnter={() => setIsYesHovered(true)}
                        onMouseLeave={() => setIsYesHovered(false)}
                    />
                    <img
                        src={isNoHovered ? no_o : no_n}
                        alt="No"
                        onClick={onClose}
                        style={{ cursor: 'pointer', margin: '0 10px' }}
                        onMouseEnter={() => setIsNoHovered(true)}
                        onMouseLeave={() => setIsNoHovered(false)}
                    />
                </div>
            </div>
        </div>
    );
};

export default CustomConfirmation;